import React from 'react';
import {connect} from 'react-redux';
import get from 'lodash/get';
import qs from 'qs';
import includes from 'lodash/includes';
import * as ResourceApi from 'api/resources';
import {resourcesSelector} from 'resources/selectors';
import EditBreakPage from 'pages/EditBreak/EditBreakPage.jsx';
import {saveResourceFieldAction} from "resources/actions";
import {startCopyChallengeAction} from "pages/BreakCopy/actions";
import {
  startPublishChallengeAction,
  startUnpublishChallengeAction,
  startValidateChallengeAction
} from "pages/BreakPublish/actions";
import {
  getUserResourceActions,
  getUserServiceActions,
  getUserGroup
} from 'pages/Profile/selectors';
import {isNoU, UserGroups, RestrictedUserGroups} from "../../utils/DBUtils";

const getAnalyticsResourceActions = getUserResourceActions(ResourceApi.Types.Analytics);

const mapDispatchToProps = dispatch => {
    return {
        persistValue: (data) => dispatch(saveResourceFieldAction(data.id, data.rootResourceId, data.resourcePath, data.fieldPath, data.field, data.value, data.parentIds, [], [])),
        showCopyBreakModal: (master) => dispatch(startCopyChallengeAction(master.id, master.permalink)),
        publishChallenge: (challenge, platforms, brk) => dispatch(startPublishChallengeAction(challenge, platforms, brk)),
        unpublishChallenge: (challenge, platforms, brk) => dispatch(startUnpublishChallengeAction(challenge, platforms, brk)),
        validateChallenge: (challenge, platforms) => dispatch(startValidateChallengeAction(challenge, platforms))
    };
};

const getBreakServiceActions = getUserServiceActions(ResourceApi.Types.PublishedBreak);

const mapStateToProps = (state, ownProps) => {
    const brk = get(state.editBreak, 'break', null);

    const breaksByPlatform = brk ? Object.keys(brk).reduce((breaks, key) => {
        const id = brk[key];
        breaks[key] = get(resourcesSelector(state.resources), id, null);
        return breaks;
    }, {}) : null;

    let query = qs.parse(ownProps.location.search.slice(1));
    let openSection = query.openSection;

    if (!isNoU(openSection) && !isNoU(state.editBreak.sectionsActiveGroups.TopLevelAccordions)) {
        let sectionInfo = state.editBreak.sectionsActiveGroups.TopLevelAccordions.find((info) => info.key === openSection);
        if (!isNoU(sectionInfo) && sectionInfo.open === true) {
            openSection = null;
        }
    }

    const userGroup = getUserGroup(state);
    const userCanViewAnalytics = includes(getAnalyticsResourceActions(state), 'READ');

    const breakServiceActions = getBreakServiceActions(state);
    const userCanPublishBreaks = includes(breakServiceActions, 'PUBLISH_BREAK');
    const userCanUnpublishBreaks = includes(breakServiceActions, 'UNPUBLISH_BREAK');

    const {fetching: searchInProgress} = state.masterSearch;

    return {
        userGroup,
        userCanViewAnalytics,
        userCanPublishBreaks,
        userCanUnpublishBreaks,
        searchInProgress,
        reducerKey: 'editBreak',
        challengeId: state.editBreak.selectedChallengeId,
        break: breaksByPlatform,
        isLoadingEditableBreak: state.editBreak.isLoadingEditableBreak,
        currentPlatform: state.editBreak.currentPlatform,
        challengeIsPublishing: state.publishChallenge.publishingChallenge,
        platformsBeingPublished: state.publishChallenge.platformsBeingPublished,
        challengeIsValidating: state.publishChallenge.validatingChallenge,
        platformsBeingValidated: state.publishChallenge.platformsBeingValidated,
        openSection: openSection
    };
};

const EditBreakPageContainer = connect(mapStateToProps, mapDispatchToProps)(EditBreakPage);

export default EditBreakPageContainer;



// WEBPACK FOOTER //
// ./public/pages/EditBreak/EditBreakPageContainer.jsx